module.exports = __webpack_public_path__ + "static/final-ed7d2e4c7c76ba1d0f7a36bd1f35bec2.mp4";